module.exports = __webpack_public_path__ + "media/icons/czesci-zamienne-menu-463b90a8.png";